/* --------------------------------------------------------------
   PV-Kostenrechner 3.0 – Shopify-Version
   --------------------------------------------------------------
   • holt pricing.json aus  window.PV_PRICING_URL   (per Liquid gesetzt)
   • cached 24 h in localStorage
   • funktioniert sowohl im <head> (DOMContentLoaded) als auch im Footer
-----------------------------------------------------------------*/
(function(){

/* ---------- Konfiguration ------------------------------------ */
const PRICING_URL = window.PV_PRICING_URL;   // wird in theme.liquid injiziert
const TTL_MS      = 86_400_000;              // 24 h

const FALLBACK = {
  "default": {
    "pv_kwp_low": 870,
    "pv_kwp_high": 1200,
    "inverter_kw": 115,
    "storage_kwh_low": 350,
    "storage_kwh_high": 450,
    "wallbox": 1000,
    "mount_share": 0.18,
    "blitz_na_fixed": 800
  },
  "ertragsfaktoren": {
    "sued_30": 1.0,
    "suedost_20": 0.93,
    "west_20": 0.87,
    "flachdach": 0.8
  }
};

/* ---------- Preise laden (mit Cache) ------------------------- */
async function fetchPricing(){
  const cached = JSON.parse(localStorage.getItem('pvPricing') || 'null');
  if (cached && Date.now() - cached.ts < TTL_MS) return cached.data;

  try{
    const data = await fetch(PRICING_URL, {cache:'no-store'}).then(r => r.json());
    localStorage.setItem('pvPricing', JSON.stringify({ts: Date.now(), data}));
    return data;
  }catch(err){
    console.warn('[PV] pricing.json nicht erreichbar – nutze Fallback', err);
    return FALLBACK;
  }
}

/* ---------- Haupt-Initialisierung ---------------------------- */
const start = () => fetchPricing().then(pricingData => {
  const p = pricingData.default;

  /* ---------- State & Hilfsfunktionen ------------------------ */
  const st = {
    step:1,totalSteps:3,
    consumption:4000,roof:40,orientation:'sued_30',
    hasHeatpump:false,hasEV:false,addStorage:true,addWallbox:false,
    result:null
  };
  const $   = sel => document.querySelector(sel);
  const fmt = n   => n.toLocaleString('de-DE');

  /* ---------- Berechnungen ---------------------------------- */
  function calc(){
    const kWp  = Math.min(st.roof / 6, 15);     // 6 m² pro kWp · Deckel 15 kWp
    const pvL  = kWp * p.pv_kwp_low;
    const pvH  = kWp * p.pv_kwp_high;
    const inv  = kWp * p.inverter_kw;

    const sSize = Math.round(st.consumption / 1000);
    const storL = st.addStorage ? sSize * p.storage_kwh_low  : 0;
    const storH = st.addStorage ? sSize * p.storage_kwh_high : 0;
    const wall  = st.addWallbox ? p.wallbox : 0;

    const matL = pvL + inv + storL + wall;
    const matH = pvH + inv + storH + wall;

    const montL = matL * p.mount_share;
    const montH = matH * p.mount_share;

    const secure = p.blitz_na_fixed;

    const totL = matL + montL + secure;
    const totH = matH + montH + secure;

    /* Break-even */
    const prod     = 950 * kWp * (pricingData.ertragsfaktoren[st.orientation] || 1);
    let   selfFrac = 0.3 + (st.addStorage ? 0.3 : 0) + (st.hasHeatpump ? 0.1 : 0) + (st.hasEV ? 0.1 : 0);
    selfFrac       = Math.min(selfFrac, 0.8);
    const kWhSelf  = Math.min(prod, selfFrac * st.consumption);
    const revenue  = kWhSelf * 0.35 + (prod - kWhSelf) * 0.08;
    const beYears  = Math.round(totL / revenue);

    st.result = {kWp:kWp.toFixed(1), matL, matH, montL, montH, secure, totL, totH, beYears};
  }

  /* ---------- Render-Funktionen ------------------------------ */
  function renderPreview(){
    if(!st.result) return;
    const {matL,matH,montL,montH,secure,totL,totH} = st.result;
    const tpl = document.importNode($('#previewTemplate').content, true);
    const box = tpl.querySelector('#previewLines');
    box.innerHTML = [
      ['PV-Anlage (Material)', `${fmt(Math.round(matL))}–${fmt(Math.round(matH))} €`],
      ['Montage & Planung',    `${fmt(Math.round(montL))}–${fmt(Math.round(montH))} €`],
      ['Sicherheit',           `≈ ${fmt(secure)} €`],
      ['Gesamt',               `${fmt(Math.round(totL))}–${fmt(Math.round(totH))} €`]
    ].map(([l,v]) => `<div class="flex justify-between"><span>${l}</span><span>${v}</span></div>`).join('');
    $('#livePreview').replaceChildren(tpl);
  }

  function renderSummary(){
    const {kWp,matL,matH,montL,montH,secure,totL,totH,beYears} = st.result;
    const tpl   = document.importNode($('#summaryTemplate').content, true);
    const lines = tpl.querySelector('#summaryLines');
    lines.innerHTML = [
      [`PV ${kWp} kWp (Material)`, `${fmt(Math.round(matL))}–${fmt(Math.round(matH))} €`],
      ['Montage & Planung',        `${fmt(Math.round(montL))}–${fmt(Math.round(montH))} €`],
      ['Sicherheit',               `≈ ${fmt(secure)} €`]
    ].map(([l,v]) => `<div class="flex justify-between"><span>${l}</span><span>${v}</span></div>`).join('');
    tpl.querySelector('#totalRange').textContent = `${fmt(Math.round(totL))}–${fmt(Math.round(totH))} €`;
    tpl.querySelector('#breakEven').textContent  = `${beYears} Jahre`;
    $('#pvSummary').replaceChildren(tpl);
  }

  /* ---------- Navigation ------------------------------------ */
  function goto(step){
    document.querySelectorAll('.step').forEach(s => s.classList.add('hidden'));
    $(`[data-step="${step}"]`).classList.remove('hidden');
    $('#progressBar').style.width = `${(step-1)/(st.totalSteps-1)*100}%`;
    st.step = step;
    $('#livePreview').classList.toggle('hidden', step !== 2);
  }

  /* ---------- Event-Binding & Initial Sync ------------------ */
  function initControls(){
    const usage  = $('#usageRange');
    const area   = $('#areaRange');
    const orient = $('#orientation');

    const setFill = r => r.style.setProperty('--fill', `${(r.value-r.min)/(r.max-r.min)*100}%`);
    [usage,area].forEach(r => { setFill(r); r.oninput = () => setFill(r); });

    function sync(){
      $('#usageOut').textContent = `${fmt(st.consumption)} kWh`;
      $('#areaOut').textContent  = `${st.roof} m²`;
      calc(); renderPreview();
    }

    usage .addEventListener('input', e => { st.consumption = +e.target.value; sync(); });
    area  .addEventListener('input', e => { st.roof        = +e.target.value; sync(); });
    orient.addEventListener('change',e => { st.orientation =  e.target.value; sync(); });

    $('#hasHeatpump').onchange = e => { st.hasHeatpump = e.target.checked; sync(); };
    $('#hasEV').onchange       = e => { st.hasEV       = e.target.checked; sync(); };
    $('#addStorage').onchange  = e => { st.addStorage  = e.target.checked; sync(); };
    $('#addWallbox').onchange  = e => { st.addWallbox  = e.target.checked; sync(); };

    /* Navigation-Buttons */
    $('#next1').onclick = () => goto(2);
    $('#back1').onclick = () => goto(1);
    $('#next2').onclick = () => { renderSummary(); goto(3); };
    $('#back2').onclick = () => goto(2);

    /* Initial Run */
    calc(); renderPreview(); goto(1);
  }

  initControls();           // alles steht – Rechner aktiv
});

/* ---------- Start je nach Ladezustand ------------------------ */
if (document.readyState === 'loading'){
  document.addEventListener('DOMContentLoaded', start);
}else{
  start();   // Script am Seitenende → DOM ist schon da
}

})();   // IIFE Ende
